// Public ↔ internal website-tab key translation (Task 1970).
//
// The internal nav key for the Current Offers built-in section is
// "current-offers" everywhere it is STORED (business_profile nav order,
// tracking-link destinations, editor section values) — renaming stored data
// would touch every user's rows for a cosmetic change. But the owner-visible
// public URL segment is the friendlier "offers":
//   useincontrol.com/?tab=offers        (copyable tab link)
//   #go-tab-offers                      (trackable-link landing hash)
// Translation happens ONLY at the public-URL boundary: emit with
// toPublicTabKey(), resolve with fromPublicTabKey(). All other keys pass
// through unchanged ("client-feedback", "tab-<id>").
export const OFFERS_INTERNAL_KEY = "current-offers";
export const OFFERS_PUBLIC_KEY = "offers";

export function toPublicTabKey(navKey: string): string {
  return navKey === OFFERS_INTERNAL_KEY ? OFFERS_PUBLIC_KEY : navKey;
}

export function fromPublicTabKey(publicKey: string): string {
  return publicKey === OFFERS_PUBLIC_KEY ? OFFERS_INTERNAL_KEY : publicKey;
}
